import { useGlobalAppState } from "@/utils/app-state";
import { useDANGEROUSisChalkEmployee } from "@/utils/hooks/use-is-chalk-employee";

/**
 * True while demo mode (mod+shift+D, see DemoModeHotkey) suppresses the red
 * nav-surface treatments. Demo mode keeps every admin-only page and item
 * visible but makes them look like their normal siblings: no red anywhere —
 * neither the "chalk employees only" tint nor the danger tone.
 *
 * Interactive surfaces (nav items, menu rows, tabs) must gate the
 * CHALK_ADMIN_SURFACE_* / CHALK_DANGER_SURFACE_* classes on this instead of
 * relying on the CSS kill-switch in styles/admin-demo-mode.css: that override
 * forces the background transparent in EVERY state, which also erases the
 * standard hover/active highlight the item would otherwise show. Skipping the
 * classes entirely leaves the item styled exactly like its non-admin
 * siblings. Static admin containers (ChalkAdminVisualWrapper) keep the CSS
 * route: they have no interactive states, so transparent-in-demo is exactly
 * right there.
 */
export const useRedSurfacesSuppressed = (): boolean => {
  const {
    state: { demoMode },
  } = useGlobalAppState();
  const isChalkEmployee = useDANGEROUSisChalkEmployee({ ignoreAdminMode: true });
  return demoMode && isChalkEmployee;
};
